import { createIcon } from '../utils';

export const EditIcon = createIcon(
  ({ ref, className, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.75 13.8801L14.9999 14.7006C14.6021 15.1357 14.0626 15.3801 13.5001 15.3801C12.9376 15.3801 12.3981 15.1357 12.0003 14.7006C11.6019 14.2664 11.0625 14.0226 10.5001 14.0226C9.93778 14.0226 9.39835 14.2664 8.99998 14.7006M2.25 15.3801H3.50591C3.87279 15.3801 4.05624 15.3801 4.22887 15.3386C4.38192 15.3019 4.52824 15.2413 4.66245 15.159C4.81382 15.0663 4.94354 14.9365 5.20296 14.6771L14.625 5.25505C15.2463 4.63373 15.2463 3.62637 14.625 3.00505C14.0037 2.38373 12.9963 2.38373 12.375 3.00505L2.95295 12.4271C2.69352 12.6865 2.5638 12.8162 2.47104 12.9676C2.3888 13.1018 2.32819 13.2482 2.29145 13.4012C2.25 13.5738 2.25 13.7573 2.25 14.1242V15.3801Z"
        stroke="currentColor"
        strokeWidth={1.4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  { displayName: 'EditIcon' },
);
